import { render } from "./PasswordResetPage.vue?vue&type=template&id=2ad44af2"
import script from "./PasswordResetPage.vue?vue&type=script&lang=js"
export * from "./PasswordResetPage.vue?vue&type=script&lang=js"

import "./PasswordResetPage.vue?vue&type=style&index=0&id=2ad44af2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__